export function objLength() {
  return (object: Record<string, unknown>) => {
    if (!object) {
      return 0;
    }

    return Object.keys(object).length;
  };
}
